const backtoPreviousLinks = document.querySelectorAll('.back-to-previous-link');
const addressUpdateForm = document.querySelector('#address_update_form');
const addressUpdateFormSubmit = document.querySelector('#address_update_form_submit');


document.addEventListener('DOMContentLoaded', function() {
  fetchGuestAddressDetails();
});

function fetchGuestAddressDetails() {
  showOhnutsLoadingSpinner();
  if (!addressUpdateForm || !addressUpdateFormSubmit) {
    hideOhnutsLoadingSpinner();
    return showOhnutsCustomModal(
      "Address update form missing",
      "Address Update Error",
      "Go to Previous Page",
      ADDRESS_LIST_URL
    );
  }
  addClassesToElements(
    '#address_update_form_submit',
    ['loading', 'read-only']
  );
  const info = getAddressIdAndRedirectURL();
  const address_id = info?.addressId || null;
  if (!address_id) {
    hideOhnutsLoadingSpinner();
    return showOhnutsCustomModal(
      "Address id missing!",
      "Address Error",
      "Go to Previous Page",
      ADDRESS_LIST_URL
    );
  }
  if (backtoPreviousLinks) {
    backtoPreviousLinks.forEach((backtoPreviousLink) => {
      backtoPreviousLink.setAttribute('href', info.redirectUrl);
    });
  }
  const oldAddress = getGuestAddressById(address_id);
  if (!oldAddress) {
    hideOhnutsLoadingSpinner();
    return showOhnutsCustomModal(
      "Failed to retrieve address",
      "Address Update Error",
      "Go to Previous Page",
      info.redirectUrl
    );
  }
  setAddressInfoIntoUpdateForm(oldAddress);
  removeClassesFromElements(
    '#address_update_form_submit',
    ['loading', 'read-only']
  );
  hideOhnutsLoadingSpinner();
}

function getAddressIdAndRedirectURL() {
  const pathname = window.location.pathname;
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const redirectUrl = urlParams.get('redirect_url') || ADDRESS_LIST_URL;
  const pathnameArray = pathname.trim().split("/");
  const addressId = pathnameArray.length
    ? pathnameArray[pathnameArray.length - 1]
    : "";

  return {
    addressId,
    redirectUrl
  };
}

function setAddressInfoIntoUpdateForm(addressInfo) {
  if (Object.keys(addressInfo).length) {
    const specialFields = [
      'default',
      'country',
      'province'
    ];
    const provinceFieldIndex = 2;
    for (const field in addressInfo) {
      if (specialFields.indexOf(field) === -1) {
        const formField = document.querySelector(`[name="address[${field}]"]`);
        if (formField) {
          formField.value = addressInfo[field];
        }
      }
    }
    specialFields.forEach((specialField, index) => {
      const formSpecialField = document.querySelector(`[name="address[${specialField}]"]`);
      if (formSpecialField && addressInfo[specialField] && (index != provinceFieldIndex)) {
        if (index) {
          formSpecialField.value = addressInfo[specialField];
          formSpecialField.dispatchEvent(new Event('change'));
        } else {
          formSpecialField.checked = true;
        }
      }
    });
    const provinceField = specialFields[provinceFieldIndex];
    const formSpecialField = document.querySelector(`[name="address[${provinceField}]"]`);
    if (formSpecialField && addressInfo[provinceField]) {
      selectDynamicallyLoadedDropdown(
        formSpecialField,
        addressInfo[provinceField]
      );
    }
  }
}

function selectDynamicallyLoadedDropdown(selectElement, targetValue) {
  const loader = setInterval(() => {
    if (areOptionsLoaded(selectElement)) {
      selectElement.value = targetValue;
      selectElement.dispatchEvent(new Event('change'));
      clearInterval(loader);
    }
  }, 100);
}

function areOptionsLoaded(selectElement) {
  const isLoaded = selectElement && selectElement.options.length > 0;
  return isLoaded;
}

if (addressUpdateFormSubmit) {
  addressUpdateFormSubmit.addEventListener('click', (e) => {
    e.preventDefault();
    showOhnutsLoadingSpinner();
    const info = getAddressIdAndRedirectURL();
    const address_id = info?.addressId || null;
    if (!address_id) {
      hideOhnutsLoadingSpinner();
      return showOhnutsCustomModal(
        "Address id missing!",
        "Address Error",
        "Go to Previous Page",
        ADDRESS_LIST_URL
      );
    }
    const oldAddress = getGuestAddressById(address_id);
    if (!oldAddress) {
      hideOhnutsLoadingSpinner();
      return showOhnutsCustomModal(
        "Failed to retrieve address",
        "Address Update Error",
        "Go to Previous Page",
        info.redirectUrl
      );
    }

    const address = validateGuestAddressUpdateForm(address_id);
    if (address) {
      updateGuestAddress(address_id, address);
      return showOhnutsCustomModal(
        "Address updated successfully",
        "Address Update",
        "Go to Previous Page",
        info.redirectUrl
      );
    }
  });
}

function validateGuestAddressUpdateForm(address_id) {
  showOhnutsLoadingSpinner();

  const valid_address = {};
  const invalid_fields = [];
  const guestAddressList = getGuestAddressList();

  function getFieldValue(selector, key, required = true) {
    const value = document.querySelector(selector).value.trim();
    if (value || !required) {
      valid_address[key] = value;
    } else {
      invalid_fields.push(key);
    }
    return value;
  }

  function getCountryAndProvince() {
    const country_ele = document.querySelector("#AddressCountryNew");
    const province_ele = document.querySelector("#AddressProvinceNew");

    const selected_country_index = country_ele.selectedIndex;
    const country_list = country_ele.options;
    const country_name = country_list[selected_country_index]?.value.trim() || "";
    if (country_name !== "---" || country_name !== "") {
      valid_address["country"] = valid_address["country_name"] = country_name;
    } else {
      invalid_fields.push("country");
    }

    let country_provinces;
    try {
      country_provinces = JSON.parse(
        country_list[selected_country_index]?.getAttribute("data-provinces") || "[]"
      );
    } catch {
      console.error(`[getCountryAndProvince] Invalid provinces JSON: ${error.message}`);
      country_provinces = [];
    }

    const selected_province_index = province_ele.selectedIndex;
    const province_list = province_ele.options;
    const province_name = province_list[selected_province_index]?.value || "";

    if (country_provinces.length) {
      if (selected_province_index >= 0 && province_name !== "") {
        valid_address["province"] = province_name;
      } else {
        invalid_fields.push("province");
      }
    } else {
      valid_address["province"] = "";
    }
  }

  function isDuplicateAddress(address_id) {
    return guestAddressList.filter(
      address => address?.id
    ).some((address) => {
      return (
        address.id !== address_id &&
        address.address1.toLowerCase() === valid_address["address1"].toLowerCase() &&
        address.city.toLowerCase() === valid_address["city"].toLowerCase() &&
        address.country.toLowerCase() === valid_address["country"].toLowerCase() &&
        address.province.toLowerCase() === valid_address["province"].toLowerCase() &&
        address.zip.toLowerCase() === valid_address["zip"].toLowerCase()
      );
    });
  }

  getFieldValue("#AddressFirstNameNew", "first_name");
  getFieldValue("#AddressLastNameNew", "last_name");
  getFieldValue("#AddressCompanyNew", "company", false);
  getFieldValue("#AddressAddress1New", "address1");
  getFieldValue("#AddressAddress2New", "address2", false);
  getFieldValue("#AddressCityNew", "city");
  getFieldValue("#AddressZipNew", "zip");
  getFieldValue("#AddressPhoneNew", "phone", false);

  valid_address["default"] = !!document.querySelector(
    "#address_default_address_new:checked"
  );

  getCountryAndProvince();

  if (invalid_fields.length) {
    hideOhnutsLoadingSpinner();
    showOhnutsCustomModal(
      "Fill up all the required fields",
      "Address Error",
      "Close"
    );
    return null;
  }

  if (isDuplicateAddress(address_id)) {
    hideOhnutsLoadingSpinner();
    showOhnutsCustomModal(
      "Address with same field info already exists!",
      "Address Error",
      "Close"
    );
    return null;
  }

  valid_address["id"] = address_id;
  valid_address["customer_id"] = "";
  valid_address["name"] = `${valid_address["first_name"]} ${valid_address["last_name"]}`.trim();

  hideOhnutsLoadingSpinner();
  return valid_address;
}
